import { createPopper } from '@popperjs/core';

const triggers = document.querySelectorAll('.tooltip-trigger');
const tooltip = document.getElementById('tooltip');
const tooltipContent = document.getElementById('tooltip-content');

let activePopper = null;

const show = (trigger) => {
    const text = trigger.getAttribute('data-tooltip');
    tooltipContent.textContent = text;

    tooltip.style.display = 'block';
    trigger.setAttribute('aria-describedby', 'tooltip');

    if (activePopper) {
        activePopper.destroy();
    }

    activePopper = createPopper(trigger, tooltip, {
        placement: 'top',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 8],
                },
            },
        ],
    });
};

const hide = () => {
    tooltip.style.display = 'none';

    if (activePopper) {
        activePopper.destroy();
        activePopper = null;
    }

    triggers.forEach((el) => {
        el.removeAttribute('aria-describedby');
    });
};

triggers.forEach((trigger) => {
    trigger.addEventListener('mouseenter', () => {
        show(trigger);
    });

    trigger.addEventListener('focus', () => {
        show(trigger);
    });

    trigger.addEventListener('mouseleave', () => {
        hide();
    });

    trigger.addEventListener('blur', () => {
        hide();
    });

    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (tooltip.style.display === 'block') {
            hide();
        } else {
            show(trigger);
        }
    });
});

document.addEventListener('click', (e) => {
    const isInsideTrigger = e.target.closest('.tooltip-trigger');
    const isInsideTooltip = e.target.closest('#tooltip');

    if (!isInsideTrigger && !isInsideTooltip) {
        hide();
    }
});
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        hide();
    }
});